import sodium from 'libsodium-wrappers-sumo';



// Convert string key into a 32-byte key using SHA-256 hash
async function getKeyFromString(keyString) {
  await sodium.ready;
  const keyBytes = sodium.from_string(keyString);
  const hash = sodium.crypto_hash_sha256(keyBytes); // Produces 32 bytes
  return hash;
}

async function decryptData(encryptedBase64, keyString) {
  try {
    await sodium.ready;
    let key = await getKeyFromString(keyString);
    let combined  = sodium.from_base64(encryptedBase64, sodium.base64_variants.ORIGINAL);
    let nonce = combined.slice(0, sodium.crypto_secretbox_NONCEBYTES);
    let ciphertext = combined.slice(sodium.crypto_secretbox_NONCEBYTES);
    let decrypted =  sodium.crypto_secretbox_open_easy(ciphertext, nonce, key);
    return sodium.to_string(decrypted);
  } catch (e) {    
    return null;
  }
}

export const fetchData = async(key,language) => {
  let encryptedFile = await fetch(`./assets/json/encrypted-data.json`);
  encryptedFile = await encryptedFile.json();  
  let jsonString = await decryptData(encryptedFile[language],key);
  return JSON.parse(jsonString);
}

export const decryptImageByIndex = async(key,index) => {
  const response = await fetch(`./assets/pictures/encrypted-file-${index+1}.txt`);
  const encryptedText = await response.text();      
  let base64String = await  decryptData(encryptedText,key);
  return  `data:image/jpeg;base64,${base64String}`;
}